module.exports = __webpack_public_path__ + "static/img/福格飯店.dc30c7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/福格飯店.png?20181011
// module id = TigQ
// module chunks = 1